import _ from '/home/ps/root'
// https://medium.com/@dan_abramov/you-might-not-need-redux-be46360cf367
// mReducer is Master_Body (mandatory config from unix as M (prop[_.M]) in this.props, and view picked from payload contain data to draw a table, or page, or error defined in view folder)
export function qApp(s = {['q'/*_INITAL*/]: {}}, {type, ...payload}) {
  switch (type) {
    case 'q': // outbound /* prop[_.M] only tirggered once in lifetime as m app (M_Body inside component/Body inside masterbody/MasterBody {a frame inside MasterLand}) basically appInitialState reach once to client
    case 'qio': // inbound /* very combursome to write Q_INITIAL */
    s = Object.assign({}, s, {
      q: payload,
    })
    break
  }
  return s
}

export default qApp
